module.exports = __webpack_public_path__ + "img/svg_cancel.e03256bb.svg";